import { useCallback } from 'react'
import { Modify } from '../../utils/globals/types'
import { changeSuccessMessage, clearAntiUnsaveElement } from '../../utils/reducers/reduxDispatch'
import { getValuesAndErrorsFromForm, sendFormByFetch, sendFormByFetchWithoutErrors } from './functions'
import { FormLogicProps, OnSubmit, ReactForm } from './types'
import useTwinTranslation from '../../utils/hooks/useTwinTranslation'

export type FormProps = Modify<ReactForm, FormLogicProps & {
}>

const TwinForm: React.FC<FormProps> = ({ onSubmit, onError, beforeSubmitHandler, children, ...formProps }) => {
    const { customFormSubmit, onKeyDownStopEnter } = useTwinFormLogic({onSubmit, onError, beforeSubmitHandler, ...formProps})
    return (
        <form {...formProps} onSubmit={customFormSubmit} onKeyDown={onKeyDownStopEnter}>
            {children}
        </form>
    )
}
const useTwinFormLogic = ({ onSubmit, onError, beforeSubmitHandler, triggerErrors = true, extraProps, startLoading, triggerSuccess = true , stopPropagation, ...processFormElementProps}: FormLogicProps) => {
    const {t} = useTwinTranslation()
    const successMessage = t('correctlyDone', 'Realizado correctamente')
    const ownOnSubmit: OnSubmit = useCallback(async (res, values) => {
        onSubmit?.(res, values)
        await clearAntiUnsaveElement()
        if (triggerSuccess) {
            changeSuccessMessage(successMessage)
        }
    }, [onSubmit, successMessage, triggerSuccess])
    const customFormSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (stopPropagation) {
            e.stopPropagation()
        }
        startLoading?.()
        const currentTarget = e.currentTarget
        const formElements = currentTarget.elements
        const { values, errors } = await getValuesAndErrorsFromForm(formElements, processFormElementProps)
        if (!errors) {
            if (!beforeSubmitHandler || beforeSubmitHandler(values, formElements)) {
                if (triggerErrors) {
                    await sendFormByFetch(values, currentTarget.action, ownOnSubmit, onError, extraProps)
                } else {
                    await sendFormByFetchWithoutErrors(values, currentTarget.action, ownOnSubmit, extraProps)
                }
            }
        }
    }, [ownOnSubmit, processFormElementProps, beforeSubmitHandler, triggerErrors, onError, extraProps, startLoading, stopPropagation])

    const onKeyDownStopEnter: React.KeyboardEventHandler<HTMLFormElement>= useCallback((e: any) => {
        if (e.key === 'Enter' && e.target?.tagName !== 'TEXTAREA') {
            e.preventDefault()
            e.stopPropagation()
        }
    }, [])
    
    return { customFormSubmit, onKeyDownStopEnter }
}


export default TwinForm